// extracted by mini-css-extract-plugin
export var formContainer = "_h8-0";
export var message = "_h8-1";